import { render, staticRenderFns } from "./quadrant.component.vue?vue&type=template&id=6a49e7b0&scoped=true&"
import script from "./quadrant.component.vue?vue&type=script&lang=ts&"
export * from "./quadrant.component.vue?vue&type=script&lang=ts&"
import style0 from "./quadrant.component.vue?vue&type=style&index=0&id=6a49e7b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a49e7b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
